import React from "react";

export const InputSelect = ({
  value,
  handleChange,
  options,
  label,
  optionsKey,
  optionsName,
  disabled,
  name,
}) => {
  return (
    <>
      <label className="text-context-inputs">{label}:</label>
      <select
        className="input-content"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        name={name}
      >
        <option value="" disabled>
          Seleccionar {label}
        </option>
        {options.map((option) => (
          <option key={option[optionsKey]} value={option[optionsKey]}>
            {option[optionsName]}
          </option>
        ))}
      </select>
    </>
  );
};
